import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { FaEdit, FaTrash, FaPlus, FaUtensils } from 'react-icons/fa';

function PackagesPage() {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPackages = async () => {
      setLoading(true);
      try {
        const querySnapshot = await getDocs(collection(db, 'packages'));
        const packagesList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPackages(packagesList);
      } catch (error) {
        console.error("Failed to fetch packages:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, []);

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete the package "${name}"?`)) {
      try {
        await deleteDoc(doc(db, 'packages', id));
        setPackages(prevPackages => prevPackages.filter(pkg => pkg.id !== id));
        alert("Package deleted successfully.");
      } catch (error) {
        console.error("Error deleting package:", error);
        alert("Failed to delete package.");
      }
    }
  };

  if (loading) {
    return <div style={styles.container}>Loading packages...</div>;
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>Subscription Packages</h2>
        <button style={styles.addButton} onClick={() => navigate('/packages/add')}>
          <FaPlus style={{ marginRight: '8px' }} />
          Add Package
        </button>
      </div>
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Package Name</th>
              <th style={styles.th}>Description</th>
              {/* ================================================================ */}
              {/* THE FIX IS HERE: Renamed the header to just "Price" for clarity. */}
              {/* ================================================================ */}
              <th style={styles.th}>Price</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {packages.map(pkg => (
              <tr key={pkg.id}>
                <td style={styles.td}>{pkg.name}</td>
                <td style={styles.td}>{pkg.description || 'No description available'}</td>
                {/* ================================================================ */}
                {/* THE FIX IS HERE: Changed pkg.pricePerMonth to pkg.price. */}
                {/* ================================================================ */}
                <td style={styles.td}>${Number(pkg.price || 0).toFixed(2)}</td>
                <td style={styles.td}>
                  <button
                    title="Edit Package"
                    style={{...styles.actionButton, ...styles.editButton}}
                    onClick={() => navigate(`/packages/edit/${pkg.id}`)}
                  >
                    <FaEdit />
                  </button>
                  <button
                    title="Manage Daily Menu"
                    style={{...styles.actionButton, ...styles.menuButton}}
                    onClick={() => navigate(`/manage-menu/${pkg.id}`)}
                  >
                    <FaUtensils />
                  </button>
                  <button
                    title="Delete Package"
                    style={{...styles.actionButton, ...styles.deleteButton}}
                    onClick={() => handleDelete(pkg.id, pkg.name)}
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// (Styles remain the same)
const styles = {
    container: {
        padding: '2rem'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem'
    },
    addButton: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 15px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '1rem'
    },
    tableContainer: {
        overflowX: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        minWidth: '600px',
    },
    th: {
        backgroundColor: '#f8f9fa',
        padding: '12px 15px',
        border: '1px solid #ddd',
        textAlign: 'left',
        fontWeight: '600'
    },
    td: {
        padding: '12px 15px',
        border: '1px solid #ddd',
        verticalAlign: 'middle'
    },
    actionButton: {
        border: 'none',
        padding: '8px 12px',
        borderRadius: '5px',
        cursor: 'pointer',
        color: 'white',
        marginRight: '5px'
    },
    editButton: {
        backgroundColor: '#28a745'
    },
    menuButton: {
        backgroundColor: '#ffc107'
    },
    deleteButton: {
        backgroundColor: '#dc3545'
    }
};


export default PackagesPage;